import { type ListingLocationProps } from '@/services/types/listings/mockListings'
import { type StoreLocation } from '@/services/types/mockStoreLocations'

export function formatShortAddressWithLocationName(location: StoreLocation | ListingLocationProps) {
  const { title, streetAddress, addressLocality, addressRegion, postalCode } = location

  const locationName = `${title}`
  const shortAddress = [streetAddress, addressLocality, addressRegion, postalCode]
    .filter(Boolean)
    .join(', ')

  return {
    locationName,
    shortAddress,
  }
}
